import React from "react";
import {IssueHistory} from "./IssueHistory";
import {IssueHistoryWidgetProps} from "./const";


export const CriticalRiskIssuesWidget: React.FC<IssueHistoryWidgetProps> = ({
    total,
    difference,
    numberOfDays,
    dataSet,
}) => {
    const args = {
        title: ["Critical risk issues", "on average"],
        subtitle: `in ${numberOfDays} day${numberOfDays === 1 ? "" : "s"}`,
        total: total,
        difference: difference,
        differenceDescription: ["Compare with", `last ${numberOfDays} day${numberOfDays === 1 ? "" : "s"}`],
        backgroundColor: "#E95B48",
        color: "#0E151B",
        showBaseline: false,
        dataSet: dataSet
    }
    return (
        <IssueHistory {...args}></IssueHistory>
    )
}
